import TestingArea from '@/views/testingarea/TestingArea.vue';
import requireAdminAccess from '@/router/guards';
import { RouteConfig } from 'vue-router';

const routes: Array<RouteConfig> = [
  {
    name: 'testingarea',
    path: '/testingarea',
    component: TestingArea,
    beforeEnter: requireAdminAccess,
    meta: {
      layout: 'full',
      auth: true
    }
  }
];

export default routes;
